"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var themes_1 = require("../../themes");
var StyledHr = styled_components_1.default.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  border: none;\n  border-bottom: 0.1rem solid ", ";\n"], ["\n  margin: 0;\n  border: none;\n  border-bottom: 0.1rem solid ", ";\n"])), function (_a) {
    var invert = _a.invert;
    return (invert ? themes_1.colors.greyColor80 : themes_1.colors.greyColor15);
});
var Divider = function (_a) {
    var invert = _a.invert, style = _a.style;
    return react_1.default.createElement(StyledHr, { invert: invert, style: style });
};
exports.Divider = Divider;
var templateObject_1;
